import {
  CreateMeasurementMutation,
  CreateMeasurementMutationVariables,
  MeasurementRefFragment,
  MeasurementRefsDocument,
  MetricsV1MeasurementInput,
  useCreateMeasurementMutation,
  withStandardCreateHook,
} from '@spotify/confidence-graphql';

export const useCreateMeasurement = withStandardCreateHook<
  CreateMeasurementMutation,
  MeasurementRefFragment,
  'createMeasurement',
  CreateMeasurementMutationVariables,
  [MetricsV1MeasurementInput, string?]
>(
  useCreateMeasurementMutation,
  'createMeasurement',
  (measurement: MetricsV1MeasurementInput, measurementId?: string) => ({
    measurement,
    measurementId,
  }),
  {
    refetchQueries: [MeasurementRefsDocument],
    awaitRefetchQueries: true,
  },
);
